import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CourierReportSettingsComponent } from './courier-report-settings.component';

@NgModule({
    declarations: [CourierReportSettingsComponent],
    imports: [CommonModule, FormsModule],
})
export class CourierReportSettingsModule {}
